(function(app) {
    var permissions = [
        { ShortName: "CanSeeAdministration", LongName: "Can see admin page", Category: "Administration" },
        { ShortName: "CanCreateManageTeams", LongName: "Can create and manage teams", Category: "Office" },
        { ShortName: "CanCreateManageWorkflows", LongName: "Can create and manage workflows", Category: "Workflows" },
        { ShortName: "CanCreateManageCarriers", LongName: "Can create and manage carriers", Category: "Administration" }
    ];

    var categories = [
        "Administration",
        "Office",
        "Workflows"
    ];

    app.provider("permissionApi",
    [
        function () {
            this.$get = [
                "$q", "crmApiGateway", function ($q, crmApiGateway) {
                    var service = {};
                    // TODO
                    service.getAll = function () {
                        return $q.when(permissions);
                        // return crmApiGateway.getArray("/Permissions");
                    };

                    service.getCategories = function () {
                        return $q.when(categories);
                        // return crmApiGateway.getArray("/Permissions/Categories");
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); // jshint ignore:line